
const newModel = () => {
    return {
        tieuchuanKhachsanId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        tieuchuanKhachsanId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        tieuchuanKhachsanId: item.tieuchuanKhachsanId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        tieuchuanKhachsanId: item.tieuchuanKhachsanId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        tieuchuanKhachsanId: null,
        ten: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        tieuchuanKhachsanId: item.tieuchuanKhachsanId,
        ten: item.ten,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        tieuchuanKhachsanId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const tieuChuanKhachSanModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


